import { render } from "./DataJam.vue?vue&type=template&id=542655cc"
import script from "./DataJam.vue?vue&type=script&lang=js"
export * from "./DataJam.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__